module.exports = __webpack_public_path__ + "static/media/2.fc3fa915.png";